import { useEffect, useState, useTransition } from "react"
import { useLazyGetVendorsQuery } from "src/api/modules/vendor-api"
import InputAutocomplete from "src/shared/components/input-autocomplete"

interface SelectVendorFieldProps {
  value: string
  onChange: (value: string, valueObj: any) => void
  label?: string
  fullWidth?: boolean
  placeholder?: string
  required?: boolean
  helperText?: string
  disableClearable?: boolean
  error?: boolean
}

const SelectVendorField = ({
  value,
  onChange,
  label,
  placeholder,
  fullWidth = true,
  required = false,
  helperText,
  disableClearable,
  error
}: SelectVendorFieldProps) => {
  const [isVendorsPending, startVendorsTransition] = useTransition()
  const [vendors, setVendors] = useState<IOptions[]>([])
  const [getVendors] = useLazyGetVendorsQuery()
  const handleGetVendors = async () => {
    startVendorsTransition(async () => {
      const response = await getVendors({
        page: 1,
        limit: 10000,
        active: true
      })
      startVendorsTransition(() => {
        setVendors(
          response.data?.data?.map(item => ({
            value: item.id ?? "",
            label: item.name ?? ""
          })) ?? []
        )
      })
    })
  }

  useEffect(() => {
    if (value && !vendors.length) {
      handleGetVendors()
    }
  }, [value])

  return (
    <InputAutocomplete
      label={label}
      loading={isVendorsPending}
      fullWidth={fullWidth}
      disableClearable={disableClearable}
      loadingText="Loading Vendors..."
      options={vendors}
      getOptionLabel={item => item.label ?? ""}
      getOptionKey={item => item.value ?? ""}
      onOpen={() => !vendors.length && handleGetVendors()}
      value={vendors.find(item => item.value === value)}
      placeholder={placeholder}
      onChange={(value: any) => {
        onChange(value?.value, value)
      }}
      required={required}
      helperText={helperText}
      error={error}
    />
  )
}

export default SelectVendorField
